module.exports = __webpack_public_path__ + "static/media/img6.3795ab4e.jpg";